import React from 'react';
import { Row, Col } from '@vds/grids';
import PropTypes from 'prop-types';

import DropdownSelect from '../../../../../common/DropdownSelect';
import ReqInput from '../../../../../common/ReqInput';
import { isMobile } from '../../../../../common/Helpers';

class PhoneNumberSelection extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      zipCode: '',
    };
  }

  componentDidMount() {
    this.setState({ zipCode: this.props.propsList.savedZipCode || this.props.zipCode });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.zipCode !== this.props.zipCode) {
      this.setState({ zipCode: this.props.zipCode });
    }
  }

  render() {
    // const npaNXX=[{key: "opt1", value: "option 1" }, { key: "opt2", value: "option 2" }, { key: "opt3", value: "option 3"}];
    const { handleZipCodeChange, disabled, displayError, mtnSelection, propsList, landline } = this.props;
    const zipcodeError = !!(propsList && propsList.getNPANXX && propsList.getNPANXX.errors);
    const mtnValue =
      propsList.getNPANXX && propsList.getNPANXX.data && propsList.getNPANXX.data.npanxxlist ? propsList.getNPANXX.data.npanxxlist : null;
    const mtn = mtnValue && mtnValue.map((item) => item.npa.concat(`-${item.nxx}-XXXX`));
    const mtnsList =
      mtn &&
      mtn.slice(0, 10).map((mtnNumber, i) => ({
        key: `dropDown${i}`,
        value: mtnNumber,
      }));

    return (
      <>
        <Row>
          <Col>
            <div className="onlyTopBorder margin18 onlyTopMargin">
              <h3 className={`margin10 noSideMargin fontWight400 ${isMobile() ? 'fontsize_20 lineHeight24' : 'fontsize_24 lineHeight28'}`}>
                {landline && landline.select_new_phone}
              </h3>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <p className={`fontsize_16 lineHeight20 letterSpacing0p5 fontWight400 ${isMobile() ? 'vdsTextGray width330' : 'width466'}`}>
              {landline && landline.select_new_phone_subcontent}
            </p>
          </Col>
        </Row>
        <Row colSizes={{ mobile: 2, tablet: 8, desktop: 4 }} data-cs-mask>
          <Col className={`zipCodeField ${isMobile() ? 'paddingTop24 width330' : 'paddingTop24'} zipCodeFieldInput`}>
            <ReqInput
              label={landline && landline.zipcode_label}
              maxLength={5}
              value={this.state.zipCode}
              onChange={(e) => handleZipCodeChange(e.target.value)}
              onBlur={() => {}}
              onKeyDown={() => {}}
              required
              error={displayError}
              errorText={this.state.zipCode === '' ? 'Required' : ''}
              id="zipCode"
            />
            {(displayError || zipcodeError) && (
              <div className="zipcodeMargin">
                {this.state.zipCode && (
                  <p
                    className="errorLabel noSideMargin displayInlineBlock fontDisplayBold"
                    style={{ fontSize: '10px', fontWeight: 'bold', marginBottom: '-100px !important' }}
                    htmlFor="zipCode"
                  >
                    Please enter a valid Zip Code
                  </p>
                )}
              </div>
            )}
          </Col>
          <Col className={isMobile() ? 'paddingTop24 width330' : 'paddingTop24'}>
            {mtnsList && (
              <DropdownSelect
                topLabelText={landline && landline.phone_number_label}
                label={landline && landline.phone_number_label_dropdown}
                disabled={disabled}
                options={mtnsList}
                handleChangeEvent={(e) => mtnSelection(e)}
                width="100%"
                required
              />
            )}
          </Col>
        </Row>
      </>
    );
  }
}

PhoneNumberSelection.propTypes = {
  landline: PropTypes.object,
  zipCode: PropTypes.string,
  propsList: PropTypes.object,
  handleZipCodeChange: PropTypes.func,
  mtnSelection: PropTypes.func,
  displayError: PropTypes.bool,
  disabled: PropTypes.bool,
};
export default PhoneNumberSelection;
